var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPaypal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "32pt",
    height: "37pt",
    viewBox: "0 0 32 37"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.145 2.883C25.402.937 22.254.102 18.227.102H6.539c-.824 0-1.527.585-1.656 1.382L.016 31.738a.991.991 0 00.992 1.137h7.219l1.812-11.266-.059.352a1.661 1.661 0 011.649-1.383h3.43c6.738 0 12.011-2.68 13.554-10.437.043-.23.086-.454.117-.672-.19-.102-.19-.102 0 0 .461-2.867 0-4.82-1.585-6.586",
    fill: "#27346a"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8 8.434c.196-.09.41-.137.63-.137h9.168c1.082 0 2.097.066 3.02.215.26.039.519.086.773.144.363.078.722.172 1.074.285.453.149.879.325 1.265.528.461-2.871 0-4.82-1.585-6.586C25.402.937 22.254.102 18.227.102H6.535c-.82 0-1.523.585-1.652 1.382L.016 31.738a.991.991 0 00.992 1.137h7.219l3.757-23.371c.079-.465.383-.863.817-1.07zm0 0",
    fill: "#27346a"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.613 10.14c-1.543 7.755-6.816 10.438-13.554 10.438h-3.43c-.824 0-1.52.59-1.649 1.383L7.727 35.973a.87.87 0 00.867.996h6.082c.722-.004 1.336-.516 1.445-1.211l.063-.305 1.144-7.121.074-.395a1.458 1.458 0 011.446-1.21h.91c5.894 0 10.508-2.348 11.855-9.133.567-2.836.274-5.203-1.215-6.867-.453-.504-1.011-.918-1.668-1.258-.035.219-.074.441-.117.672zm0 0",
    fill: "#2790c3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.117 8.836a12.713 12.713 0 00-1.496-.324 19.214 19.214 0 00-3.023-.215h-9.164a1.414 1.414 0 00-.633.14 1.43 1.43 0 00-.813 1.07L10.04 21.61l-.055.352a1.654 1.654 0 011.645-1.383h3.43c6.738 0 12.011-2.68 13.554-10.437.047-.23.086-.454.121-.672a7.92 7.92 0 00-1.27-.524 9.04 9.04 0 00-.347-.11",
    fill: "#1f264f"
  })));
}

export default SvgPaypal;